import type { ReactNode } from 'react'
import React from 'react'
import { useDocLink } from '../../../hooks/useDocLink'
import { Link } from '../../Link'
import type { Blog } from '@ztechapps/common.contract'

export type DocLinkProps = {
  slug: string
  children: ReactNode
}

export const DocLink = ({ slug, children }: DocLinkProps) => {
  const { url } = useDocLink({ slug } as Blog)

  return (
    <Link reloadDocument to={url}>
      {children}
    </Link>
  )
}
